export const insertHyphens = (text) => {
    if (!text) { return '' }

    return text.replace(/(\|)/g, '&shy')
}
